<mat-card class="cb-margin flex-col flex">
    <mat-card-content>
        <div class="flex-row flex">
            @if (mappedItem) {
                <div class="cb-margin-right-2x flex-col flex-33">
                    <div class="start-center flex-row">
                        <mat-icon class="cb-margin-right" [ngClass]="getHtmlClassFromStatus()">
                            label
                        </mat-icon>
                        <h3
                            class="mat-headline-6 product-status"
                            [ngClass]="getHtmlClassFromStatus()"
                        >
                            {{ mappedItem.productType | cbEnumToLabel: PRODUCT_TYPE_ENUM }}
                            {{ getStatusText() }}
                        </h3>
                    </div>
                    <cb-image-gallery [images]="imageUrls"></cb-image-gallery>
                    @if (mappedItem.status > 1) {
                        <div class="flex-col">
                            <div class="cb-margin-top start-center flex-row">
                                <mat-icon class="cb-warn cb-margin-right">warning</mat-icon>
                                <h3 class="mat-headline-6 cb-warn product-status">
                                    {{
                                        mappedItem.status ===
                                        OFFERING_STATUS_ENUM.TemporarilyUnavailable
                                            ? 'Unavailable'
                                            : 'Inactive'
                                    }}&nbsp;
                                </h3>
                                <span class="flex"></span>
                            </div>
                            <mat-divider
                                style="margin: 8px 0 8px 0; position: static; width: auto"
                            ></mat-divider>
                            @if (
                                mappedItem.unavailableReason &&
                                mappedItem.status === OFFERING_STATUS_ENUM.PermanentlyUnavailable
                            ) {
                                <cb-display-value-new
                                    label="Reason"
                                    value="{{ OFFERING_STATUS_ENUM[mappedItem.status] }}"
                                >
                                </cb-display-value-new>
                            }
                            @if (
                                mappedItem.status === OFFERING_STATUS_ENUM.TemporarilyUnavailable
                            ) {
                                <cb-display-value-new label="Unavailable Period">
                                    <cb-user-date-time-new [date]="mappedItem.unavailableStartDate">
                                    </cb-user-date-time-new>
                                    &nbsp; to
                                    <cb-user-date-time-new [date]="mappedItem.unavailableEndDate">
                                    </cb-user-date-time-new>
                                </cb-display-value-new>
                            }
                            @if (
                                mappedItem.status === OFFERING_STATUS_ENUM.PermanentlyUnavailable
                            ) {
                                <cb-display-value-new label="Inactive Start Date">
                                    <cb-user-date-time-new [date]="mappedItem.unavailableStartDate">
                                    </cb-user-date-time-new>
                                </cb-display-value-new>
                            }
                            @if (mappedItem.replacementOffering) {
                                <cb-display-value-new label="Replacement Product">
                                    <span class="start-center flex-row">
                                        {{ mappedItem?.replacementOffering?.name }}
                                        <mat-icon
                                            style="height: 2px; margin-top: -20px; cursor: pointer"
                                            (click)="viewProduct(mappedItem.replacementOfferingId)"
                                            >pageview</mat-icon
                                        >
                                    </span>
                                </cb-display-value-new>
                            }
                            @if (mappedItem.statusComment) {
                                <cb-text-area
                                    label="Comments"
                                    name="comments"
                                    [(ngModel)]="mappedItem.statusComment"
                                    [readonly]="true"
                                >
                                </cb-text-area>
                            }
                        </div>
                    }
                </div>
            }
            @if (mappedItem) {
                <div class="flex-col flex-66">
                    <h3 class="mat-headline-6">
                        {{ mappedItem.code }} {{ mappedItem.name }}
                        @if (mappedItem.isStandardProduct) {
                            <cb-display-pill [displayPillText]="'Standard'"></cb-display-pill>
                        }
                    </h3>
                    @if (compositeProduct) {
                        <cb-display-value-new
                            label="Composite Item"
                            [value]="getCompositeItemLabel()"
                            [showBtn]="true"
                            (click)="viewCompositeProduct()"
                        >
                        </cb-display-value-new>
                    }
                    <cb-display-value-new
                        label="UOM"
                        [value]="UNIT_OF_MEASURE_ENUM[mappedItem.uom]"
                    >
                    </cb-display-value-new>
                    <cb-display-value-new label="Categories">
                        <ul class="simple-breadcrumbs">
                            @for (cat of mappedItem.categoryPath; track cat) {
                                <li>{{ cat.label }}</li>
                            }
                        </ul>
                    </cb-display-value-new>
                    @if (mappedItem.isLabour()) {
                        <cb-display-value-new
                            label="Trade Type"
                            [value]="mappedItem.tradeType.label"
                        >
                        </cb-display-value-new>
                    }
                    <cb-display-value-new label="Notes" [value]="mappedItem.notes">
                    </cb-display-value-new>
                    <span class="cb-margin"></span>
                    @if (mappedItem.isCompositeItem) {
                        <cb-table
                            [loaded]="true"
                            [stringColumns]="assignedItemsColumns"
                            tableLabel="Assigned Items"
                            class="cb-margin-bottom-2x"
                        >
                            <tbody cbTableBody>
                                @for (
                                    componentItem of mappedItem.componentItems;
                                    track componentItem
                                ) {
                                    <tr>
                                        <td>
                                            {{ componentItem.code }}
                                        </td>
                                        <td>
                                            {{ componentItem.name }}
                                        </td>
                                        <td>
                                            {{ UNIT_OF_MEASURE_ENUM[componentItem.uom] }}
                                        </td>
                                        <td>
                                            @for (
                                                value of componentItem?.categoryPath;
                                                track value;
                                                let last = $last
                                            ) {
                                                {{ value?.label }}
                                                @if (!last) {
                                                    <span> > </span>
                                                }
                                            }
                                        </td>
                                        <td
                                            cbTableShrinkCol
                                            cbTableStickyCol="end"
                                            class="layoutGap-4"
                                        >
                                            <button
                                                mat-icon-button
                                                (click)="viewProductFromTableAction(componentItem)"
                                            >
                                                <mat-icon>pageview</mat-icon>
                                            </button>
                                            <button
                                                mat-icon-button
                                                (click)="manageProduct(componentItem)"
                                            >
                                                <mat-icon>edit</mat-icon>
                                            </button>
                                            <button
                                                mat-icon-button
                                                (click)="removeCompositeItem(componentItem)"
                                            >
                                                <mat-icon>remove_circle</mat-icon>
                                            </button>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </cb-table>
                    }
                    @if (mappedItem.isProduct() && !mappedItem.isCompositeItem) {
                        <cb-table
                            [loaded]="true"
                            [stringColumns]="restrictionsColumns"
                            tableLabel="Restrictions"
                            class="cb-margin-bottom-2x"
                        >
                            <tbody cbTableBody>
                                @for (restriction of mappedItem.restrictions; track restriction) {
                                    <tr>
                                        <td>{{ restriction.name }}</td>
                                        <td>{{ restriction.category.label }}</td>
                                        <td>
                                            @for (
                                                value of restriction?.options;
                                                track value;
                                                let last = $last
                                            ) {
                                                {{ value?.name }}
                                                @if (!last) {
                                                    <span>, </span>
                                                }
                                            }
                                        </td>
                                        <td cbTableShrinkCol cbTableStickyCol="end">
                                            <button
                                                mat-icon-button
                                                (click)="editProductAttribute(restriction)"
                                            >
                                                <mat-icon>edit</mat-icon>
                                            </button>
                                        </td>
                                    </tr>
                                }
                                <tr>
                                    @if (
                                        !mappedItem.restrictions ||
                                        mappedItem.restrictions.length === 0
                                    ) {
                                        <td>
                                            <cb-info-message
                                                [message]="'There are no Restrictions to display'"
                                                [icon]="'info'"
                                            ></cb-info-message>
                                        </td>
                                    }
                                    <td colspan="5" [style.textAlign]="'right'">
                                        <button mat-icon-button (click)="addAttribute()">
                                            <mat-icon>add</mat-icon>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </cb-table>
                    }
                    @if (mappedItem?.isBundle()) {
                        <div class="cb-margin-bottom">
                            <h3 class="mat-headline-6 cb-margin-bottom">Bundle Items</h3>
                            <div class="standardTable">
                                <table>
                                    <thead>
                                        <tr>
                                            <td></td>
                                            <td>Item Code</td>
                                            <td>Item Name</td>
                                            <td>Quantity</td>
                                            <td [style.width.px]="60">Status</td>
                                            @if (mappedItem.bundleTemplateId != undefined) {
                                                <td>Required</td>
                                            }
                                            <td></td>
                                        </tr>
                                    </thead>
                                    @if (mappedItem.bundleTemplateId == undefined) {
                                        <tbody>
                                            @for (
                                                product of mappedItem.products
                                                    | cbSortByPipe: 'offering' : 'asc';
                                                track product
                                            ) {
                                                <tr>
                                                    <td></td>
                                                    <td>{{ product.offeringId }}</td>
                                                    <td>{{ product.offering }}</td>
                                                    <td>{{ product.quantity }}</td>
                                                    <td>
                                                        <mat-icon>{{
                                                            product.isChangeable
                                                                ? 'lock_open'
                                                                : 'lock_outline'
                                                        }}</mat-icon>
                                                    </td>
                                                    <td class="actions">
                                                        <button
                                                            mat-icon-button
                                                            (cbClick)="
                                                                viewProduct(product.offeringId)
                                                            "
                                                        >
                                                            <mat-icon>pageview</mat-icon>
                                                        </button>
                                                        <button
                                                            [disabled]="!product.isChangeable"
                                                            mat-icon-button
                                                            (cbClick)="
                                                                editBundleProductWithoutTemplate(
                                                                    product
                                                                )
                                                            "
                                                        >
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                        <button
                                                            mat-icon-button
                                                            (cbClick)="removeBundleProduct(product)"
                                                        >
                                                            <mat-icon>remove_circle</mat-icon>
                                                        </button>
                                                    </td>
                                                </tr>
                                            }
                                            <tr>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td class="actions">
                                                    <button
                                                        style="float: right"
                                                        mat-icon-button
                                                        (cbClick)="addProductToBundle()"
                                                    >
                                                        <mat-icon>add</mat-icon>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    }
                                    @if (mappedItem.bundleTemplateId != undefined) {
                                        @for (
                                            item of mappedItem.templateItems;
                                            track item;
                                            let index = $index;
                                            let last = $last
                                        ) {
                                            @if (mappedItem.bundleTemplateItemProduct(item.id)) {
                                                <tbody>
                                                    <tr>
                                                        <td colspan="2"></td>
                                                        <td colspan="5" class="mat-body-strong">
                                                            {{ item.name }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="actions">
                                                            @if (
                                                                mappedItem.bundleTemplateItemProduct(
                                                                    item.id
                                                                ).hasImage
                                                            ) {
                                                                <mat-icon> photo </mat-icon>
                                                            }
                                                            @if (
                                                                mappedItem.bundleTemplateItemProduct(
                                                                    item.id
                                                                ).inSpec
                                                            ) {
                                                                <mat-icon> style </mat-icon>
                                                            }
                                                        </td>
                                                        <td>
                                                            {{
                                                                mappedItem.bundleTemplateItemProduct(
                                                                    item.id
                                                                ).offeringId || '-'
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                mappedItem.bundleTemplateItemProduct(
                                                                    item.id
                                                                ).offering || '-'
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                mappedItem.bundleTemplateItemProduct(
                                                                    item.id
                                                                ).quantity || '-'
                                                            }}
                                                        </td>
                                                        <td class="actions">
                                                            <mat-icon>{{
                                                                item.isLocked ? 'lock' : 'lock_open'
                                                            }}</mat-icon>
                                                        </td>
                                                        <td class="actions">
                                                            @if (item.isRequired) {
                                                                <mat-icon> check_box </mat-icon>
                                                            }
                                                            @if (!item.isRequired) {
                                                                <mat-icon>
                                                                    check_box_outline_blank
                                                                </mat-icon>
                                                            }
                                                        </td>
                                                        <td class="actions">
                                                            @if (
                                                                mappedItem.bundleTemplateItemProduct(
                                                                    item.id
                                                                ).offeringId != undefined
                                                            ) {
                                                                <button
                                                                    mat-icon-button
                                                                    (cbClick)="
                                                                        viewBundleProduct(
                                                                            mappedItem.bundleTemplateItemProduct(
                                                                                item.id
                                                                            )
                                                                        )
                                                                    "
                                                                >
                                                                    <mat-icon>pageview</mat-icon>
                                                                </button>
                                                            }
                                                            <button
                                                                [disabled]="
                                                                    getBundleTemplateItemDisabled(
                                                                        mappedItem,
                                                                        item
                                                                    )
                                                                "
                                                                mat-icon-button
                                                                (cbClick)="
                                                                    editBundleProductWithTemplate(
                                                                        mappedItem.bundleTemplateItemProduct(
                                                                            item.id
                                                                        ),
                                                                        item
                                                                    )
                                                                "
                                                            >
                                                                <mat-icon>edit</mat-icon>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                    @if (mappedItem.templateItems.length < 1) {
                                                        <tr>
                                                            <td colspan="7">
                                                                <div class="start-center flex-row">
                                                                    <mat-icon class="mat-accent"
                                                                        >info</mat-icon
                                                                    >
                                                                    <span
                                                                        >&nbsp;There are no Bundle
                                                                        Items to display</span
                                                                    >
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            }
                                            @if (!mappedItem.bundleTemplateItemProduct(item.id)) {
                                                <tbody>
                                                    <tr>
                                                        <td colspan="2"></td>
                                                        <td colspan="5" class="mat-body-strong">
                                                            {{ item.name }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6"></td>
                                                        <td class="actions">
                                                            <button
                                                                mat-icon-button
                                                                (cbClick)="
                                                                    addProductToTemplatedBundle(
                                                                        mappedItem.bundleTemplateItemProduct(
                                                                            item.id
                                                                        ),
                                                                        item
                                                                    )
                                                                "
                                                            >
                                                                <mat-icon>add</mat-icon>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            }
                                        }
                                    }
                                </table>
                            </div>
                        </div>
                    }
                    @if (!mappedItem.isCompositeItem) {
                        <cb-checkbox
                            label="Include in Flyer / Create Schedule"
                            [readonly]="true"
                            [(ngModel)]="mappedItem.showInClientSpecs"
                            [slim]="true"
                        >
                        </cb-checkbox>
                        <cb-checkbox
                            label="Included in Colour Schedule"
                            [readonly]="true"
                            [(ngModel)]="mappedItem.showInColourYourDreams"
                            [slim]="true"
                        >
                        </cb-checkbox>
                        <cb-checkbox
                            label="Manual Colour Entry Required"
                            [readonly]="true"
                            [(ngModel)]="mappedItem.manualColourEntryRequired"
                            [slim]="true"
                        >
                        </cb-checkbox>
                        @if (mappedItem.showInClientSpecs) {
                            <cb-display-value-new
                                label="Spec Details"
                                [value]="mappedItem.clientSpecDescription"
                            >
                            </cb-display-value-new>
                        }
                    }
                </div>
            }
        </div>
        @if (mappedItem && !mappedItem?.isBundle() && canViewRates()) {
            <div class="flex">
                <form class="flex" #ratesSearchForm="ngForm">
                    <div class="flex-col">
                        <mat-divider
                            style="margin: 8px 0 20px 0; position: static; width: auto"
                        ></mat-divider>
                        <div class="start-center flex-row flex">
                            <cb-select
                                label="Supplier"
                                name="supplier"
                                [(ngModel)]="userCacheService.productSearch.data.selectedSupplier"
                                [options]="suppliers"
                                class="cb-margin-right-3x"
                            >
                            </cb-select>
                            <cb-checkbox
                                label="Show Future Rates"
                                name="showFutureRates"
                                class="cb-margin-right-3x"
                                [slim]="true"
                                [(ngModel)]="userCacheService.productSearch.data.showFutureRates"
                            >
                            </cb-checkbox>
                            <cb-checkbox
                                label="Show Inactive Rates"
                                name="showInactiveRates"
                                class="cb-margin-right-3x"
                                [slim]="true"
                                [(ngModel)]="userCacheService.productSearch.data.showInactiveRates"
                            >
                            </cb-checkbox>
                            <span class="flex"></span>
                            <cb-checkbox
                                label="Rates are Maintained for this Product"
                                [readonly]="true"
                                [slim]="true"
                                name="shouldMaintainRatesForThisProduct"
                                [(ngModel)]="mappedItem.shouldMaintainRatesForThisProduct"
                            >
                            </cb-checkbox>
                        </div>
                        <div class="flex-col flex">
                            <mat-tab-group
                                class="flex"
                                mat-stretch-tabs="false"
                                (selectedTabChange)="scrollDown()"
                            >
                                @for (ratesForRegion of rateRegions; track ratesForRegion) {
                                    <mat-tab label="{{ ratesForRegion.region.label }}">
                                        <div class="cb-margin-top flex-row">
                                            <div class="flex-col flex">
                                                @if (!mappedItem.isCompositeItem) {
                                                    <div
                                                        class="standardTable"
                                                        cb-double-horiz-scroll="1000"
                                                        id="scrollId"
                                                    >
                                                        <table>
                                                            <thead>
                                                                <tr>
                                                                    @if (mappedItem.isProduct()) {
                                                                        <td>Supplier SKU</td>
                                                                    }
                                                                    <td>Supplier</td>
                                                                    <td>Location</td>
                                                                    <td>Project</td>
                                                                    <td>Rate</td>
                                                                    @if (
                                                                        !mappedItem.isCompositeItem
                                                                    ) {
                                                                        <td>Date Rate Applies</td>
                                                                    }
                                                                    @if (
                                                                        !mappedItem.isCompositeItem
                                                                    ) {
                                                                        <td>Updated</td>
                                                                    }
                                                                    @if (
                                                                        !mappedItem.isCompositeItem
                                                                    ) {
                                                                        <td>Updated By</td>
                                                                    }
                                                                    <td></td>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                @for (
                                                                    rate of ratesForRegion.rates
                                                                        | cbCallback: rateFilter;
                                                                    track rate
                                                                ) {
                                                                    <tr
                                                                        [ngClass]="{
                                                                            'table-warn':
                                                                                !rate.isActive,
                                                                            'table-accent':
                                                                                isFutureRate(rate)
                                                                        }"
                                                                    >
                                                                        @if (
                                                                            mappedItem.isProduct()
                                                                        ) {
                                                                            <td>
                                                                                {{
                                                                                    rate.sku
                                                                                        | cbDasher
                                                                                }}
                                                                            </td>
                                                                        }
                                                                        <td>
                                                                            {{
                                                                                rate.vendor
                                                                                    | cbDasher
                                                                            }}
                                                                        </td>
                                                                        <td>
                                                                            <ul
                                                                                class="simple-breadcrumbs"
                                                                            >
                                                                                @for (
                                                                                    area of rate.areaPath;
                                                                                    track area
                                                                                ) {
                                                                                    <li>
                                                                                        {{
                                                                                            area.label
                                                                                                | cbDasher
                                                                                        }}
                                                                                    </li>
                                                                                }
                                                                            </ul>
                                                                        </td>
                                                                        <td>
                                                                            {{
                                                                                rate.projectTitle
                                                                                    | cbDasher
                                                                            }}
                                                                        </td>
                                                                        <td>
                                                                            {{
                                                                                rate.value
                                                                                    | currency
                                                                            }}
                                                                        </td>
                                                                        <td>
                                                                            <cb-user-date-time-new
                                                                                [date]="
                                                                                    rate.appliedRatesFrom
                                                                                "
                                                                                [displayTime]="
                                                                                    false
                                                                                "
                                                                            >
                                                                            </cb-user-date-time-new>
                                                                        </td>
                                                                        <td>
                                                                            <cb-user-date-time-new
                                                                                [date]="
                                                                                    rate.updatedDate
                                                                                "
                                                                                [displayTime]="
                                                                                    false
                                                                                "
                                                                            >
                                                                            </cb-user-date-time-new>
                                                                        </td>
                                                                        <td>
                                                                            {{
                                                                                rate?.updatedBy
                                                                                    ?.firstName
                                                                            }}
                                                                            {{
                                                                                rate?.updatedBy
                                                                                    ?.lastName
                                                                            }}
                                                                        </td>
                                                                        <td class="actions">
                                                                            <button
                                                                                mat-icon-button
                                                                                title="Edit Rate"
                                                                                (cbClick)="
                                                                                    manageRate(rate)
                                                                                "
                                                                                class="cb-margin-right"
                                                                            >
                                                                                <mat-icon
                                                                                    >edit</mat-icon
                                                                                >
                                                                            </button>
                                                                            @if (
                                                                                rate.businessAccountId
                                                                            ) {
                                                                                <button
                                                                                    mat-icon-button
                                                                                    title="View Supplier"
                                                                                    (cbClick)="
                                                                                        viewBusinessAccount(
                                                                                            rate.businessAccountId
                                                                                        )
                                                                                    "
                                                                                >
                                                                                    <mat-icon
                                                                                        >pageview</mat-icon
                                                                                    >
                                                                                </button>
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                }
                                                                @if (
                                                                    !(
                                                                        ratesForRegion.rates
                                                                        | cbCallback: rateFilter
                                                                    ).length
                                                                ) {
                                                                    <tr>
                                                                        <td colspan="9">
                                                                            There are no rates for
                                                                            this Product with the
                                                                            selected filters
                                                                        </td>
                                                                    </tr>
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                }
                                                @if (mappedItem.isCompositeItem) {
                                                    <div
                                                        class="standardTable"
                                                        cb-double-horiz-scroll="1000"
                                                        id="scrollId"
                                                    >
                                                        <table>
                                                            <thead>
                                                                <tr>
                                                                    <td>Supplier</td>
                                                                    <td>Location</td>
                                                                    <td>Project</td>
                                                                    <td>Rate</td>
                                                                    <td></td>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                @for (
                                                                    rate of ratesForRegion.rates
                                                                        | cbCallback
                                                                            : compositeRateFilter;
                                                                    track rate
                                                                ) {
                                                                    <tr
                                                                        [ngClass]="{
                                                                            'table-warn':
                                                                                !rate.locations[0]
                                                                                    .isActive,
                                                                            'table-accent':
                                                                                isFutureRate(
                                                                                    rate
                                                                                        .locations[0]
                                                                                )
                                                                        }"
                                                                    >
                                                                        <td>
                                                                            {{
                                                                                rate.supplier
                                                                                    | cbDasher
                                                                            }}
                                                                        </td>
                                                                        <td>
                                                                            <ul
                                                                                class="simple-breadcrumbs"
                                                                            >
                                                                                @for (
                                                                                    area of rate.locations;
                                                                                    track area
                                                                                ) {
                                                                                    <li>
                                                                                        {{
                                                                                            area
                                                                                                ? area.locationLabel
                                                                                                : ''
                                                                                        }}
                                                                                    </li>
                                                                                }
                                                                            </ul>
                                                                        </td>
                                                                        <td>
                                                                            {{
                                                                                rate.locations[0]
                                                                                    .projectTitle
                                                                                    | cbDasher
                                                                            }}
                                                                        </td>
                                                                        <td>
                                                                            {{
                                                                                rate.locations[0]
                                                                                    .aggregateValue
                                                                                    | currency
                                                                                    | cbDasher
                                                                            }}
                                                                        </td>
                                                                        <td class="actions">
                                                                            <button
                                                                                mat-icon-button
                                                                                title="View Rate Composition"
                                                                                (cbClick)="
                                                                                    openRateCompositionDialog(
                                                                                        rate
                                                                                    )
                                                                                "
                                                                            >
                                                                                <mat-icon
                                                                                    >forward</mat-icon
                                                                                >
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                }
                                                                @if (
                                                                    !(
                                                                        ratesForRegion.rates
                                                                        | cbCallback
                                                                            : compositeRateFilter
                                                                    ).length
                                                                ) {
                                                                    <tr>
                                                                        <td colspan="5">
                                                                            There are no rates for
                                                                            this Product with the
                                                                            selected filters
                                                                        </td>
                                                                    </tr>
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </mat-tab>
                                }
                            </mat-tab-group>
                        </div>
                    </div>
                </form>
            </div>
        }
    </mat-card-content>
</mat-card>
